import { render } from "./business.vue?vue&type=template&id=35c1d8f8&scoped=true"
import script from "./business.vue?vue&type=script&lang=js"
export * from "./business.vue?vue&type=script&lang=js"

import "./business.vue?vue&type=style&index=0&id=35c1d8f8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-35c1d8f8"

export default script